module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-mostpopular-6-0f12d9f9018208df61a646ae891bd870.webp";